<template>
  <!-- <div class="event-lists gift d-flex flex-wrap justify-content-between"> -->
  <div>
    <div
      class="modal fade form-wrapper"
      id="giftDetailsModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="formModalLabel"
      aria-hidden="true"
      v-if="showModal"
      @close="closeModal"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content form-content">
          <div class="modal-body">
            <div class="img-upload d-flex flex-wrap align-items-center justify-content-center">
              <img
                class="close"
                src="../../../public/assets/images/close.svg"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              />
              <img
                :src="getGiftDetails.productImage.length!=0?getGiftDetails.productImage[0].image:'/img/event1.287e79dd.png'"
                style="height : 100%;"
              />
            </div>
            <div class="create-form">
              <h4 class="giftTitle">{{getGiftDetails.productName}}</h4>
              <div class="product-price">
                <p v-if="getGiftDetails.productPrice">${{getGiftDetails.productPrice}}</p>
                <p v-else>$0</p>
              </div>
              <p class="desire">{{desire}}</p>

              <div class="row">
                <div class="column col-md-4 col-sm-6 col-xs-6">
                  <!--<p class="list-head">Color</p>-->
                  <p class="list-head">Size</p>
                  <p class="list-head">QTY</p>
                  <p class="list-head">Total quantity purchased</p>
                  <!-- <p class="list-head">You have purchased</p> -->
                  <p class="list-head" v-if="getGiftDetails.giftPurchasedBy && isExpired === true">Purchased By</p>
                  <!-- <p class="list-head">You have purchased</p> -->
                  <p class="list-head" v-if="isExpired === false">Your purchase quantity</p>
                </div>
                <div class="column col-md-2 col-sm-6 col-xs-6">
                  <!--<p
                    class="details"
                    v-if="getGiftDetails.productColor"
                  >{{getGiftDetails.productColor}}</p> 
                  <p class="details" v-else>&nbsp;</p>-->

                  <p
                    class="details"
                    v-if="getGiftDetails.productSize"
                  >{{getGiftDetails.productSize}}</p>
                  <p class="details" v-else>&nbsp;</p>

                  <p
                    class="details"
                    v-if="getGiftDetails.productQuantity"
                  >{{getGiftDetails.productQuantity}}</p>
                  <p class="details" v-else>&nbsp;</p>

                  <p
                    class="details"
                    v-if="getGiftDetails.purchasedQuantity"
                  >{{getGiftDetails.purchasedQuantity}}</p>
                  <p class="details" v-else>0</p>

                  <p class="details-class"                    
                    v-if="getGiftDetails.giftPurchasedBy && isExpired === true"
                  ><table class="table">
                  <thead>
                 
                  </thead>
                    <tbody>
                    <tr v-for="item in getGiftDetails.giftPurchasedBy">
                      <td>{{item.name}}</td>
                      <td class="product-price"><p>{{item.purchasedQuantity}}</p></td>
                    </tr>
                    </tbody>
                  </table></p>
                  <p class="details" v-else>&nbsp;</p>
                  <div class="form-group" v-if="isExpired === false">
                    <input
                      type="number"
                      class="form-control"
                      :value="purchasedQuantity"
                      data-vv-as="purchase quantity"
                      id="purchasedQuantity"
                      name="purchasedQuantity"
                      :min=0
                      @change="(e) => purchasedQuantityChanged(e)"
                    /> 
                      <!-- v-model="purchasedQuantity" -->
                    <!-- :min="minimumPurchasedQuantity" -->
                    <!-- v-validate="minimumQuantityValidation" -->


                  </div>
                   
                </div>
                <!-- <div class="column col-md-2"></div> -->
                <div class="column col-md-6">
                  <p class="list-head">More details</p>
                  <p class="more-detail">{{getGiftDetails.detail}}</p>
                </div>
                <div class="invalid-feedback">{{ errors.first('purchasedQuantity') }}</div>
              </div>

              <div
                class="alert alert-primary alert-dismissible"
                role="alert"
                v-if="showSuccessAlertMessage === true"
              >
                {{apiSuccessMessage}}
                <img
                  class="close"
                  src="../../../public/assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showSuccessAlertMessage = !showSuccessAlertMessage"
                />
              </div>
              <div
                class="alert alert-danger alert-dismissible"
                role="alert"
                v-if="showAlertMessage === true"
              >
                {{apiErrorMessage}}
                <img
                  class="close"
                  src="../../../public/assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showAlertMessage = !showAlertMessage"
                />
              </div>

             <!--  <div class="purchase-button" v-if="getGiftDetails.remainingQuantity == 0">
                <button
                  type="button"
                  class="btn btn-primary"
                  disabled="disabled"
                >This gift has been purchased</button>
              </div> -->
              <!-- <div
                class="purchase-button"
                v-if="isExpired === false && getGiftDetails.remainingQuantity !== 0"
              > -->
              <div
                class="purchase-button"                
              >
                <div
                  v-if="(showSpinner === true)"
                  class="spinner-border"
                  style="width: 3rem; height: 3rem;color:#FD3E75;"
                  role="status"
                ></div>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="purchaseGift"
                  :disabled="disabled === true"
                >{{buttonText}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { PURCHASE_GIFT, SET_GIFT_DETAILS } from "../../store/gift/action.type";
export default {
  props: {
    show: Boolean,
    isExpired: Boolean,
    celebrantName: String,
    showPurchasedAmount: Boolean
  },
  data() {
    return {
      purchasedQuantity: 0,
      showAlertMessage: false,
      apiSuccessMessage: "",
      showSuccessAlertMessage: false,
      apiErrorMessage: "",
      disabled: false,
      buttonText: "Mark as purchased",
      showSpinner: false,
      minimumPurchasedQuantity: 0
    };
  },
 
  computed: {
    showPurchasedAmounts() {
      this.getGiftDetails.giftPurchasedBy.forEach(purchased => {
        if (this.userDetails._id === purchased.userId) {
          this.purchasedQuantity = purchased.purchasedQuantity;
          this.minimumPurchasedQuantity = purchased.purchasedQuantity;
        } 
      });
      
    },
    showModal() {
      this.getGiftDetails.giftPurchasedBy.map(purchased => {
        if (this.userDetails._id === purchased.userId) {
          this.purchasedQuantity = purchased.purchasedQuantity;
          this.minimumPurchasedQuantity = purchased.purchasedQuantity;
        } 
      });
      return this.show === true
        ? $("#giftDetailsModal").modal("show")
        : $("#giftDetailsModal").modal("hide");
    },

    ...mapGetters(["getGiftDetails"]),

    ...mapState({
      userDetails: state => state.auth.userDetails
    }),

    desire() {
      switch (this.getGiftDetails.want) {
        case "No Preference":
          return `${this.celebrantName} has no preference for this`;

        case "Useful":
          return `${this.celebrantName} finds this useful`;

        case "Wants":
          return `${this.celebrantName} wants this`;

        case "Really Wants":
          return `${this.celebrantName} really wants this`;

        case "Must Have":
          return `This is must have for ${this.celebrantName}`;

        default:
          break;
      }
    },
     minimumQuantityValidation() {
      return {
        min_value : this.minimumPurchasedQuantity
      }
    }
  },
  methods: {
    closeModal() {
      this.$validator.reset();
      this.$emit(
        "closeGiftDetailsModal",
        this.purchasedQuantity,
        this.getGiftDetails._id,
        this.getGiftDetails.giftPurchasedBy
      );
      this.purchasedQuantity = 0; //reset the modal purchasedQuantity data
    },

    purchaseGift() {
      let purchaseDetails = {
        purchasedQuantity: this.purchasedQuantity,
        giftId: this.getGiftDetails._id,
        wishlistId: this.getGiftDetails.wishlist.wishlistId
      };
      this.disabled = true;
      this.buttonText = "Please wait...";
      this.showSpinner = true;
      this.$store
        .dispatch(PURCHASE_GIFT, purchaseDetails)
        .then(response => {
          if (response.status == 200) {
            this.$store.dispatch(SET_GIFT_DETAILS, response.data.data); //set the gift purchased response
            this.apiSuccessMessage = response.data.message;
            this.showSuccessAlertMessage = true;
            setTimeout(() => {
              this.closeModal();
            }, 1000);
          } else {
            this.apiErrorMessage = response.data.message;
            this.showAlertMessage = true;
          }
          this.disabled = false;
          this.buttonText = "Mark as purchased";
          this.showSpinner = false;
        })
        .catch(error => {
          this.disabled = false;
          this.buttonText = "Mark as purchased";
          this.showSpinner = false;
          this.apiErrorMessage = error.response.data.message;
          this.showAlertMessage = true;
        });
    },
    purchasedQuantityChanged(e) {
      this.purchasedQuantity = e.target.value;
      console.log("PQ", this.purchasedQuantity);
    }
  },
  watch: {
    showAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showAlertMessage = false;
        }, 2000);
      }
    },
    showSuccessAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showSuccessAlertMessage = false;
        }, 2000);
      }
    },
    purchasedQuantity: {
      handler: function(val) {
        console.log("Handler", val);
      }
    }
  }
};
</script>

<style>
.giftTitle{
  word-wrap:anywhere;
}
.details-class{
  max-height: 300px;

  overflow-y: scroll;

  overflow-x: hidden;

  margin-right: -19px;
}
table{
  border:0px !important;
  margin-top:10px;
}
table td{
  padding-left:0px !important;
  padding-bottom:0px !important;
  padding-top:10px !important;
  font-size:0.9rem;
  border:none !important;
}
.list-head {
  color: #6d5b97 !important;
  margin-top: 17px !important;
}
.create-form h3 {
  font-family: "Rubik", sans-serif;
  color: #212529;
  margin-top: 5px;
  margin-bottom: 0;
}

.details {
  margin-top: 17px !important;
  color: #3f3d55;
}
.column .more-detail {
  margin-top: 10px;
}

::-webkit-scrollbar {
  height: 10px;
  width: 4px;
  background: #ddd;
}

::-webkit-scrollbar-thumb {
  background: rgb(143, 141, 141);
  -webkit-border-radius: 1ex;
}

/* .account-payment-detail {
  margin-bottom: 0px;
} */

.form-group input {
  border-width: 0 0 0.0625rem 0;
  background: transparent;
  padding-left: 0px;
}

.product-price {
  color: #fd3e75;
  margin-bottom: 10px;
}

.desire {
  margin-top: 10px;
  color: #3f3d55;
  margin-bottom: 10px;
}
</style>